import { useEffect, useState } from 'react';
import { PlanT } from '@csi-monorepo/core/domain/insurance';
import HeaderProvider from '@src/components/Header/ContextHeader';
import useScroll from '@src/hooks/screen/useScroll';
import Layout from '@src/layouts/layout';
import useAppStore from '@src/stores/useAppStore';
import LandingBenefitsAssists from '@src/templates/LandingBenefits/LandingBenefitsAssists/LandingBenefitsAssists';
import LandingBenefitsExclusive from '@src/templates/LandingBenefits/LandingBenefitsExclusive/LandingBenefitsExclusive';
import LandingBenefitsHero from '@src/templates/LandingBenefits/LandingBenefitsHero/LandingBenefitsHero';
import LandingBenefitsLayout from '@src/templates/LandingBenefits/LandingBenefitsLayout';
import LandingBenefitsSteps from '@src/templates/LandingBenefits/LandingBenefitsSteps/LandingBenefitsSteps';
import { benefitsLandingViewPageEvent } from '@src/utils/dataLayer/benefits';
import { NextPage } from 'next';

const LandingPage: NextPage = () => {
  const { insurance } = useAppStore();
  const [executeScroll, scrollRef] = useScroll();
  const [hasElite, setHasElite] = useState(false);

  useEffect(() => {
    setHasElite(!!insurance?.plans?.find((plan: PlanT) => plan?.name === 'Élite'));
  }, [insurance?.plans]);

  useEffect(() => {
    benefitsLandingViewPageEvent();
  }, []);

  return (
    <HeaderProvider>
      <Layout isLanding>
        <LandingBenefitsLayout>
          <LandingBenefitsHero scrollable={executeScroll} />
          {hasElite && <LandingBenefitsAssists scrollRef={scrollRef} />}
          <LandingBenefitsExclusive scrollRef={!hasElite ? scrollRef : undefined} />
          <LandingBenefitsSteps />
        </LandingBenefitsLayout>
      </Layout>
    </HeaderProvider>
  );
};

export default LandingPage;
